/**
 * 配列の最大個数チェックバリデーション.
 * 配列長が指定の長さ以内であること
 */
export default {
  validate(
    value: unknown[] | undefined | null,
    { max }: { max: number }
  ): boolean {
    if (!value) {
      return true;
    }

    return value.length <= max;
  },
};
